var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Vue, Component, Prop, Watch, Ref } from "vue-facing-decorator";
import { SystemComponentsClient, ComponentTypesClient, GetSystemComponentViewListQuery, ComponentModel, ComponentsClient, UpdateComponentCommand, ComponentTypeEnum } from "@/app/api/battery-portal-api";
import { Notifier } from "@/common/utils/notifier";
import { HttpHelper } from "@/app/utils/http-helper";
import { TextHelper } from "@/app/utils/text-helper";
import { useForm } from 'vee-validate';
import * as yup from 'yup';
const componentClient = new ComponentsClient(window.apiUrl);
const systemComponentClient = new SystemComponentsClient(window.apiUrl);
const componentTypeClient = new ComponentTypesClient(window.apiUrl);
let SystemConfigurationVue = class SystemConfigurationVue extends Vue {
    constructor() {
        super(...arguments);
        // simpletons
        this.componentsLoaded = false;
        this.treeLoaded = false;
        this.working = false;
        this.editingComponent = false;
        this.pageNo = 1;
        this.pageSize = 50;
        // models
        // NOTE: systemId is assigned in created() because with vue-facing-decorator v4
        // class field initializers run before @Prop values are bound on the instance,
        // so `this.systemId` is undefined here.
        this.componentQuery = new GetSystemComponentViewListQuery({
            systemId: null,
            componentTypeId: null,
            includeDeleted: false,
            keywords: null
        });
        this.component = new ComponentModel();
        // arrays
        this.systemComponents = [];
        this.componentTypes = [];
    }
    created() {
        this.componentQuery.systemId = this.systemId;
        this.getLookups();
        this.getConfiguration();
    }
    ;
    // get
    getConfiguration() {
        this.getSystemComponents();
        this.initComponent();
    }
    ;
    getSystemComponents() {
        if (this.working)
            return;
        this.working = true;
        systemComponentClient
            .search(this.componentQuery)
            .then(response => {
            this.systemComponents = response;
            this.pageNo = 1;
            this.componentsLoaded = true;
        })
            .catch(ex => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        }).finally(() => {
            this.working = false;
        });
    }
    ;
    getLookups() {
        componentTypeClient
            .getList()
            .then(response => {
            this.componentTypes = (response || []).map(item => {
                return {
                    value: item.componentTypeId,
                    text: item.componentTypeName
                };
            });
        })
            .catch(ex => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        });
    }
    ;
    // set
    editSystemComponent(item) {
        this.editingComponent = true;
        let component = new ComponentModel();
        component.init({});
        component.componentId = item.componentId;
        component.systemId = this.systemId;
        component.componentCode = item.componentCode;
        component.componentName = item.componentName;
        component.componentTypeId = item.componentTypeId;
        component.registrationKey = item.registrationKey;
        component.serialNumber = item.serialNumber;
        this.component = component;
        this.setValues({
            componentCode: component.componentCode,
            componentName: component.componentName,
            componentTypeId: this.componentType
        });
    }
    ;
    saveSystemComponent() {
        if (this.working)
            return;
        if (this.component.componentTypeId == ComponentTypeEnum.String || this.component.componentTypeId == ComponentTypeEnum.Block) {
            if (isNaN(Number(this.component.componentCode))) {
                Notifier.onWarning("The code must be a numeric value for String and Block type components!");
                return;
            }
        }
        // validate
        const handleSubmitAction = this.handleSubmit(() => {
            let component = this.component;
            let promise = () => {
                return componentClient.update(component.componentId, new UpdateComponentCommand({ requestModel: component }));
            };
            this.working = true;
            promise()
                .then(() => {
                Notifier.onOk();
                this.configurationChanged(component);
                this.editingComponent = false;
                this.working = false;
                this.getConfiguration();
            })
                .catch((ex) => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            }).finally(() => {
                this.working = false;
            });
        }, () => {
            Notifier.onError("Please check that you have entered all details correctly.");
        });
        handleSubmitAction();
    }
    ;
    cancelSystemComponentChanges() {
        this.editingComponent = false;
        this.initComponent();
    }
    ;
    archiveSystemComponent(item) {
        if (this.working)
            return;
        this.$confirmModal.show("Are you sure you want to archive this component", { title: "Please Confirm" })
            .then((value) => {
            if (!value)
                return;
            this.working = true;
            systemComponentClient
                .delete(item.systemId, item.componentId)
                .then(() => {
                Notifier.onOk();
                this.configurationChanged(item);
                ;
                this.working = false;
                this.getConfiguration();
            })
                .catch(ex => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            })
                .finally(() => {
                this.working = false;
                this.editingComponent = false;
            });
        });
    }
    ;
    restoreSystemComponent(item) {
        if (this.working)
            return;
        this.working = true;
        systemComponentClient
            .restore(item.systemId, item.componentId)
            .then(() => {
            Notifier.onOk();
            this.configurationChanged(item);
            ;
            this.working = false;
            this.getConfiguration();
        })
            .catch(ex => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
            this.editingComponent = false;
        });
    }
    ;
    initComponent() {
        let component = new ComponentModel();
        component.init({
            systemId: this.systemId,
            companyId: this.companyId
        });
        this.resetForm();
        this.component = component;
    }
    ;
    // computed
    get loaded() {
        return this.componentsLoaded && this.treeLoaded;
    }
    ;
    get selectPlaceholder() {
        return TextHelper.emptyListItemName;
    }
    ;
    get componentTypeId() {
        return this.component.componentTypeId;
    }
    ;
    get isNewComponent() {
        return !this.component.componentId;
    }
    ;
    get isArchivedComponent() {
        return this.component.whenDeleted ? true : false;
    }
    ;
    get componentType() {
        return this.componentTypes.filter(item => {
            return item.value == this.component.componentTypeId;
        })[0] || null;
    }
    ;
    set componentType(item) {
        this.setFieldValue("componentTypeId", item);
        if (!item)
            return;
        this.component.componentTypeId = item.value;
    }
    ;
    configurationChanged(item) {
        if (item == null)
            return;
        this.$emit("onSystemConfigurationChangedEvent", item);
    }
    ;
    get systemComponentsPage() {
        try {
            if (!this.systemComponents)
                return [];
            let end = this.pageSize * this.pageNo;
            let start = end - this.pageSize;
            start = start >= 0 ? start : 0;
            end = end >= this.systemComponents.length ? this.systemComponents.length : end;
            let virtualSystemComponents = [];
            for (var i = start; i < end; i++) {
                virtualSystemComponents.push(this.systemComponents[i]);
            }
            return virtualSystemComponents;
        }
        catch (e) {
            console.error(e);
            return [];
        }
    }
};
__decorate([
    Prop(),
    __metadata("design:type", Boolean)
], SystemConfigurationVue.prototype, "disableControls", void 0);
__decorate([
    Prop(),
    __metadata("design:type", Number)
], SystemConfigurationVue.prototype, "systemId", void 0);
__decorate([
    Prop(),
    __metadata("design:type", Number)
], SystemConfigurationVue.prototype, "companyId", void 0);
__decorate([
    Ref(),
    __metadata("design:type", Object)
], SystemConfigurationVue.prototype, "componentsDiv", void 0);
__decorate([
    Watch("componentQuery.includeDeleted"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], SystemConfigurationVue.prototype, "getConfiguration", null);
SystemConfigurationVue = __decorate([
    Component({
        name: "SystemConfigurationVue",
        emits: ["onSystemConfigurationChangedEvent"],
        setup() {
            const { errors, handleSubmit, defineInputBinds, defineComponentBinds, setFieldValue, setValues, resetForm } = useForm({
                validationSchema: yup.object({
                    componentCode: yup.string().trim().required(),
                    componentName: yup.string().trim().required(),
                    componentTypeId: yup.object().listOptionRequired(),
                })
            });
            const componentCodeVal = defineInputBinds('componentCode');
            const componentNameVal = defineInputBinds('componentName');
            const componentTypeIdVal = defineComponentBinds('componentTypeId');
            return {
                errors,
                handleSubmit,
                setFieldValue,
                setValues,
                resetForm,
                componentCodeVal,
                componentNameVal,
                componentTypeIdVal,
            };
        }
    })
], SystemConfigurationVue);
export default SystemConfigurationVue;
